import { type AmountType } from '@alfa-bank/newclick-types';

export const defaultAmount: AmountType = { value: null, minorUnits: 100, currency: 'RUR' };

export const MIN_TRANSFER_VALUE = 1000;
export const MIN_TRANSFER_SUM = '10\u00A0₽';

export const defaultError = {
    title: 'Что-то пошло не так',
    subtitle: 'Нам нужно немного времени, чтобы всё заработало',
};
